import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import * as authSelector from '../../features/auth/selectors';
import { HelpersService } from '../services/helpers.service';
import { PermissionService } from '../services/permission.service';

@Directive({
  selector: '[appCheckPermission]'
})
export class CheckPermissionDirective implements OnInit, OnDestroy {
  private onDestroy$ = new Subject<boolean>();
  @Input() permission?: string;
  @Input('appCheckPermission')
  set appCheckPermission(value: string | null | undefined) {
    this.permission = value ?? undefined;
  }
  @Input() permissions?: string[];
  @Input('appCheckPermissionPermissions')
  set appCheckPermissionPermissions(value: string[] | null | undefined) {
    this.permissions = value ?? undefined;
  }
  @Input() requireLegalEntityContext: boolean = false;
  @Input('appCheckPermissionRequireLegalEntityContext')
  set appCheckPermissionRequireLegalEntityContext(value: boolean | null | undefined) {
    this.requireLegalEntityContext = !!value;
  }
  constructor(
    private store: Store,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private helperService: HelpersService,
    private permissionService: PermissionService
  ) {
    this.viewContainer.clear();
  }

  ngOnInit(): void {
    if (this.permission || (this.permissions && this.permissions.length > 0)) {
      const permissionsToCheck = this.permission ? [this.permission] : (this.permissions || []);
      this.permissionService.hasAnyPermission(permissionsToCheck, this.requireLegalEntityContext)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(hasPermission => {
          if (hasPermission) {
            this.viewContainer.clear();
            this.viewContainer.createEmbeddedView(this.templateRef);
          } else {
            this.viewContainer.clear();
          }
        });
    } else {
      this.store.pipe(select(authSelector.selectBusinessUserRole), takeUntil(this.onDestroy$)).subscribe(roles => {
        if (!!roles && this.helperService.permissionValidation(roles.role)) {
          this.viewContainer.clear();
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
          this.viewContainer.clear();
        }
      });
    }
  }
  ngOnDestroy(): void {
    this.onDestroy$.next(true);
    this.onDestroy$.unsubscribe();
  }
}
